import { Navigate } from 'react-router-dom';

import Error403 from '../../modules/errorPages/Error403';

import { errorPagesConfigs } from '../../@crema/core/AppRoutes/ErrorPagesRoutes';
import { appsConfig } from './AppRoutes';
import { authRouteConfig } from './AuthRoutes';

export const authorizedStructure = (loginUrl: string) => {
  return {
    fallbackPath: loginUrl,
    unAuthorizedComponent: <Error403 />,
    routes: [...appsConfig],
  };
};

export const publicStructure = (initialUrl: string) => {
  return {
    fallbackPath: initialUrl,
    routes: authRouteConfig,
  };
};
export const anonymousStructure = (initialUrl: string) => {
  return {
    routes: errorPagesConfigs.concat([
      {
        path: '/',
        element: <Navigate to={initialUrl} />,
      },
      {
        path: '*',
        element: <Navigate to='/error-pages/error-404' />,
      },
    ]),
  };
};
